<template>
  <div class="container-fluid mb-6 mb-md-0">
    <div class="header mt-4 mt-md-0">
      <div class="header-body">
        <div class="row align-items-end">
          <div class="col">
            <h6 class="header-pretitle">
              계정 정보
            </h6>
            <h1 class="header-title">
              {{ centerAccount.name }}
            </h1>
          </div>
        </div>

        <div class="row align-items-center">
          <div class="col">
            <ul class="nav nav-tabs nav-overflow header-tabs">
              <li
                v-for="subMenu in subMenus"
                class="nav-item nav-link"
                :class="{'active': subMenu.value === curSubMenu}"
                @click="handleClickSubMenu(subMenu)"
              >
                {{ subMenu.name }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <AccountCenterProfileEdit v-show="curSubMenu === 'center'" />
    <AccountEdit v-show="curSubMenu === 'account'" />
  </div>
</template>

<script>
import mapView from "@/directives/MapView.js";
import PageHeaderWithTab from "../../components/element-ui/PageHeaderWithTab";
import FiflFooter from "../../components/FiflFooter";
import ElLoadingButton from "../../components/el-loading-button";
import { computedGetters } from "../../utils/vuex-helper";
import { ACCOUNT_ROLE } from '@/constants';
import AccountCenterProfileEdit from "./AccountCenterProfileEdit";
import AccountEdit from "./AccountEdit";

export default {
	name: "Account",
	components: {
		AccountEdit,
		AccountCenterProfileEdit,
		ElLoadingButton,
		FiflFooter,
		PageHeaderWithTab,
	},
	directives: { mapView },
	data() {
		return {
			subMenus: [
				{
					value: "center",
					name: "센터 정보",
				},
				{
					value: "account",
					name: "계정",
				},
			],
			curSubMenu: "center",
		};
	},
	computed: {
		...computedGetters([
			'centerAccount',
			'role',
			'isOwnerAccount'
			]),
	},
	watch:{
		role:{
			immediate:true,
			handler:function(value){
				if(value === ACCOUNT_ROLE.INSTRUCTOR){
					this.subMenus = this.subMenus.slice(1);
					this.curSubMenu = 'account';
				}
			}
		}
	},
	methods: {
		handleClickSubMenu(subMenu) {
			this.curSubMenu = subMenu.value;
		},
	},
};
</script>

<style lang="scss">
.block-form {
	padding: 32px 46px;
}

.form-bottom-area {
	margin-top: 20px;
	height: 44px;
	position: relative;
	text-align: center;
	padding-top: 9px;

	.form-bottom-description {
		font-size: 14px;
		line-height: 22px;
		color: #9b9b9b;
	}

	.form-bottom-controller {
		position: absolute;
		right: 0;
		bottom: 0;
		height: 42px;
	}
}
</style>
